import { colors, Grid, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { AuditListingProps } from 'src/types';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

export const ProductLabelAndStatus: FC<AuditListingProps> = ({
  availableListingCount,
  auditedCount
}) => {
  return (
    <Grid item xs={12} container>
      <Grid item xs>
        <Typography variant="h6">Product Name:</Typography>
      </Grid>
      <Grid
        item
        xs={1}
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Grid item xs={12}>
          {auditedCount !== availableListingCount ? (
            <WarningIcon
              style={{
                color: colors.yellow[800],
                marginRight: '8px'
              }}
            />
          ) : (
            <CheckCircleIcon
              style={{
                color: colors.green[800],
                marginRight: '8px'
              }}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
